import GlobeLogo from "../images/globe.png"

export default function Header() {
    return (

        <div className="header-container">
            <img src={GlobeLogo} alt="globe" className="globe-image"></img>
            <div className="header-content">my travel journal</div>
        </div>

    )
}